import { PocketsDateType } from './pockets-date-type.model';
import { PocketsReportInterval } from './pockets-interval.model';
import { PocketsReportType } from './pockets-report-type.model';

export enum PocketsFilterKeys {
  Accounts = 'accounts',
  Addresses = 'addresses',
  Brands = 'brands',
  SubBrands = 'subBrands',
  Delivered = 'delivered',
  OrderType = 'ordertype',
  AssociatedAccounts = 'associatedAccounts',
  FromDate = 'fromDate',
  ToDate = 'toDate',
  AttributeFilters = 'attributeFilters',
  Category = 'category',
  Division = 'division',
  Color = 'color',
  MasterCategory = 'masterCategory',
  Gender = 'gender',
  Noos = 'noos',
  ProductType = 'producttype',
  Query = 'query',
}

export interface AttributeFilter {
  attribute: string;
  values?: string[];
}

export interface PocketsFilters {
  [PocketsFilterKeys.Accounts]?: string[];
  [PocketsFilterKeys.Brands]?: string[];
  [PocketsFilterKeys.SubBrands]?: string[];
  [PocketsFilterKeys.Delivered]?: boolean[];
  [PocketsFilterKeys.OrderType]?: number[];
  [PocketsFilterKeys.AssociatedAccounts]?: string[];
  [PocketsFilterKeys.FromDate]?: string;
  [PocketsFilterKeys.ToDate]?: string;
  [PocketsFilterKeys.AttributeFilters]?: AttributeFilter[];
  [PocketsFilterKeys.Query]?: string;
}

export interface PocketsRequestDto {
  type: PocketsReportType;
  interval: PocketsReportInterval;
  filters: PocketsFilters;
  intervalDateType: PocketsDateType;
  // sorting: {
  //   field: string,
  //   direction: string
  // },
  includeSizeCurve?: boolean;
  sorting: {
    field: number;
    direction: number;
  };
}

export interface PocketsFilterResponseDto {
  filters: FilterItem[];
}

export interface FilterItem {
  id: string;
  values: [
    {
      name: string;
      count: number;
    },
  ];
}
